import { reactive } from 'vue';
import { io } from 'socket.io-client';

export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: [],
});

let socket = null;

export function connect(url, token) {
  const parsed = new URL(url);
  const origin = parsed.origin;
  const socketPath = parsed.pathname.replace(/\/$/, '') + '/socket.io';

  socket = io(origin, {
    path: socketPath,
    autoConnect: false,
    // Meilleure pratique: passer le token via auth au lieu de query
    auth: {
      token: token,
    },
    // Options recommandées:
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
    transports: ['websocket', 'polling'], // websocket en priorité
  });

  socket.on('connect_error', (error) => {
    console.error('WebSocket connection error:', error);
  });

  socket.connect();
  return socket;
}

// Fonction utilitaire pour mettre à jour le token (utile si token expire)
export function updateToken(newToken) {
  if (socket) {
    socket.auth = { token: newToken };
    socket.disconnect().connect();
  }
}
